import { render, staticRenderFns } from "./TimelineBody.vue?vue&type=template&id=2fc60fac&scoped=true"
import script from "./TimelineBody.vue?vue&type=script&lang=js"
export * from "./TimelineBody.vue?vue&type=script&lang=js"
import style0 from "./TimelineBody.vue?vue&type=style&index=0&id=2fc60fac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc60fac",
  null
  
)

export default component.exports